import React from 'react';
import { motion } from 'framer-motion';
import { steps } from '../data/faqs';
export function Steps() {
  return <section aria-label="Comment ça marche" className="bg-warm" data-id="element-239" data-mp="18d1ranxk8i7w">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "12px",
      paddingBottom: "22px"
    }} data-id="element-240" data-mp="umy9c95prao9">
        <div className="text-center" data-id="element-241" data-mp="yni81h5xqmci">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-242" data-mp="ymgw7ah3hvtq">
            Comment progresser à partir d'aujourd'hui
          </h2>
          <p className="mt-3 text-base text-navy/60" data-id="element-243" data-mp="poens9v180wf">En 3 étapes simples</p>
        </div>

        <ol className="relative mt-12 grid gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-244" data-mp="bovswir8em22">
          <span aria-hidden="true" className="absolute bottom-6 left-[21px] top-6 w-px bg-electric/30 lg:bottom-auto lg:left-[22px] lg:right-[22px] lg:top-[21px] lg:h-px lg:w-auto" data-id="element-245" data-mp="fow5dxursn6h" />
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-5 lg:flex-col lg:gap-5" data-id="element-246" data-mp="2a3ypfg11vd20" data-mpi={i}>
              <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-electric font-display text-xl font-extrabold text-white" data-id="element-247" data-mp="200lx3489xzsj">
                {s.n}
              </span>
              <div data-id="element-248" data-mp="17cq347a3alzg">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-navy" data-id="element-249" data-mp="12delyx5t9ehc">{s.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-250" data-mp="1hadymzfirxio">{s.body}</p>
                {s.tags.length > 0 && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-251" data-mp="1cbb7miwdjrtp">
                    {s.tags.map(t => <li key={t} className="rounded-md border border-navy/10 bg-white px-2.5 py-1 text-xs font-medium text-navy/75" data-id="element-252" data-mp="2spkj4cfipm34">
                        {t}
                      </li>)}
                  </ul>}
                {s.after && <p className="mt-3 text-[15px] leading-relaxed text-navy/70" data-id="element-253" data-mp="2uupigg994300">{s.after}</p>}
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}